import {Typography} from '@mui/material';
import {t} from 'i18next';
import React from 'react';
import {AurButton} from '../common/aur-button/AurButton';
import {ReactComponent as RightIcon} from '../../assests/svg/right-icon-fixerror.svg';
interface IBulkUploadErrorState {
  errorCount: number;
  totalErrorCount: number;
  onFixErrorClick: () => void;
}
const BulkUploadErrorState: React.FC<IBulkUploadErrorState> = ({
  errorCount,
  totalErrorCount,
  onFixErrorClick,
}) => {
  return (
    <div
      className={
        errorCount > 0 ? 'userserror-container' : 'usersuccess-container'
      }
      aria-label={t('common.polite')}
    >
      {/* //div for backgroung  color hen errors are present */}
      {errorCount > 0 ? <div className="background"></div> : null}{' '}
      <div
        className={errorCount > 0 ? 'team-members-error' : 'team-members-error'}
      >
        <div className={errorCount === 0 ? 'noerror-color' : 'error-color'}>
          <Typography className="typo-text display3_size" gutterBottom>
            {errorCount}
          </Typography>
        </div>
        <Typography
          className="typo-text body2_size error-text mist_100"
          gutterBottom
        >
          {errorCount === 1
            ? ` ${t('common.bulkUploadModule.teamMemberWithError')}`
            : `${t('common.bulkUploadModule.teamMembersWithError')}`}{' '}
        </Typography>
      </div>
      <div className="totalerrors ">
        <div className={errorCount === 0 ? 'noerror-color' : 'error-color'}>
          <Typography className="typo-text display3_size" gutterBottom>
            {totalErrorCount}
          </Typography>
        </div>
        <Typography
          className="typo-text body2_size error-text mist_100 "
          gutterBottom
        >
          {totalErrorCount === 1
            ? ` ${t('common.bulkUploadModule.totalError')}`
            : t('common.bulkUploadModule.totalErrors')}
        </Typography>
      </div>
      {errorCount > 0 && (
        <div className="fixerrors-button">
          <AurButton
            classNames="addxmembers-btn"
            aria-describedby="fixErrorsHint"
            dataTestId="fixerrorbutton-test"
            type="continue"
            endIcon={<RightIcon aria-hidden="true" />}
            label={t('buttons.fixErrors')}
            size="Medium"
            onClick={onFixErrorClick}
          />
          {/* text for accessibility */}
          <span id="fixErrorsHint" className="fix-errors-hint">
            fix errors individually across CSV file.
          </span>
          {/* text ends for accessibility */}
        </div>
      )}
    </div>
  );
};

export default BulkUploadErrorState;
